module.exports = __webpack_public_path__ + "1b79a2f2a4cd49e85174c9799ca5a74e.svg";